var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "arrow-left.b92d7133.png","uri@2x": __webpack_public_path__ + "arrow-left.cdf60580.png","uri@3x": __webpack_public_path__ + "arrow-left.635830a4.png",
    width: 18,
    height: 12
});